export default defineNuxtRouteMiddleware((to) => {
  if (!to.fullPath.includes("?"))
    return;

  const urlWithoutQuery = to.fullPath.split("?")[0];

  if (!urlWithoutQuery.endsWith("/"))
    return navigateTo({ path: `${to.path}/`, query: to.query });
});
